import { createSlice, createAction } from '@reduxjs/toolkit';

type NotificationLevel = 'success' | 'error' | 'info';
export const supressNotifications = createAction('/appModal/SUPRESS_NOTIFICATIONS', ({ level}: { level: NotificationLevel }) => {
    return {
        payload: { level }
    };
});
export const unsupressNotifications = createAction('/appModal/UNSUPRESS_NOTIFICATIONS', ({ level }: { level: NotificationLevel }) => {
    return {
        payload: { level }
    };
});
export const showModal = createAction('/appModal/SHOW_MODAL');
export const hideModal = createAction('/appModal/HIDE_MODAL');

const modalSlice = createSlice({
    name: 'appModal',
    initialState: {
        open: false,
        successNotifications: false,
        errorNotifications: false,
        infoNotifications: false
    },
    reducers: { },
    extraReducers: (builder) => {
        builder.addMatcher(showModal.match, (state) => {
            state.open = true;
        });

        builder.addMatcher(hideModal.match, (state) => {
            state.open = false;
        });

        builder.addMatcher(supressNotifications.match, (state, { payload }) => {
            switch (payload.level) {
                case 'success':
                    state.successNotifications = false
                    break;
                case 'error':
                    state.errorNotifications = false
                    break;
                case 'info':
                    state.infoNotifications = false
                    break;
                default:
                    break;
            }
        });

        builder.addMatcher(unsupressNotifications.match, (state, { payload }) => {
            switch (payload.level) {
                case 'success':
                    state.successNotifications = true
                    break;
                case 'error':
                    state.errorNotifications = true
                    break;
                case 'info':
                    state.infoNotifications = true
                    break;
                default:
                    break;
            }
        });
    }
});

export default modalSlice;